import { useQuery } from '@tanstack/react-query';
import { adminSiteService } from '@ui/services';

const adminSitesQuery = () => {
  return {
    queryKey: ['admin', 'sites', 'all'],
    queryFn: () => adminSiteService.getAll(),
  };
};

export function useAdminSites() {
  return useQuery({
    ...adminSitesQuery(),
  });
}
